import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

import { Link } from 'gatsby'


class DeveloperMobile extends React.Component {

  shouldComponentUpdate() {
    return false
  }
  

    render() {

      const Section = styled.section`
      position: relative;
      overflow: hidden;
      background-color: #000;      
  `

      const AboutCol = styled(Col)`
      display: flex;
      align-items: center;
  `

      const ImageCol = styled(Col)`
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 767px) {
        .image-col {
            text-align: center;
        }
    }
  `

      const ImageWrapper = styled.div`
      text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }      
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `
      const Main = styled.div`
      padding: 100px 0 150px 0;
      background-color: #fff;
      @media (max-width: 767px) {
          padding: 100px 0;
      }
      @media (min-width: 768px) and (max-width: 1500px) {
          padding: 50px 0 0px 0;
      }
      @media (min-width: 1501px) and (max-width: 1600px) {
          padding: 200px 0;
      }
  `      
      const Heading = styled.h2`
      font-size: 60px;
      line-height: 70px;
      font-family: "Montserrat", sans-serif;
      color: #1b2a2f;
      font-weight: bold;      
      @media (min-width:768px) and (max-width:1600px) {
          font-size: 50px;
          line-height: 70px;
      }
      @media (max-width:767px) {
          font-size: 30px;
          line-height: 50px;
          text-align: left;
      }
  `

      const Heading3 = styled.h3`
        font-size: 40px;
        line-height: 60px;
        font-family: "Montserrat", sans-serif;        
        font-weight: bold;        
        @media (min-width:768px) and (max-width:5000px) {
          font-size: 30px;
          line-height: 50px;
        }
        @media (max-width:767px) {
          font-size: 30px;
          line-height: 30px;
          text-align: left;
        }
        @media (min-width:5001px) and (max-width:1600px) {
          font-size: 40px;
          line-height: 50px;
          margin-top: 50px;
        }
      `
      
      const Color = styled.span`
      color: #ef0d33;
      font-size: 75px;
      line-height: 70px;
      font-family: Teko;
      text-transform: uppercase;
      letter-spacing: 2px;
      @media (min-width:768px) and (max-width:1600px) {
          font-size: 80px;
          line-height: 40px;
      }
      @media (max-width:767px) {
          font-size: 40px;
          line-height: 40px;
      }
  `      

      const AboutContent = styled.div`
      padding: 0 20%;
      @media (max-width: 767px) {
          padding: 30px 5%;
      }
      @media (min-width: 768px) and (max-width:1600px) {
          padding: 0 5%;
      }
  `

      const Separator = styled.div`
      height: 5px;
      width: 50px;
      background-color: #ef0d33;
      margin-bottom: 20px;
  `

      const Text = styled.p`
      font-size: 18px;
      line-height: 26px;      
      font-weight: 300;
      color: #1a1a1a;
`
      const Headinga = styled(Link)`        
        color: #78c91c;
        transition: .5s;
          &:hover {
            color: #000;
            text-decoration: none;
          }
      `

        return(
          <Section id="devmobile">
            <Main>
              <Row>
                <ImageCol md={6}>
                  <ImageWrapper>
                    
                      <GatsbyImage image={this.props.image} alt="Desarrollo de Aplicaciones Móviles en Pereira" sizes="(max-width: 767px) 300px, 500px" />
                    
                  </ImageWrapper>
                </ImageCol>
                <AboutCol md={6}>
                  <Col md={12}>
                    
                      <AboutContent>
                        <Heading>
                          Aplicaciones <Color>Móviles</Color>
                        </Heading>
                        <Separator />
                        <Text>
                          <span role="img" aria-label="Index Pointing Up">☝️</span> en el desarrollo de aplicaciones móviles, nativas o Cross-Platform
                          (multiplataforma, mas económicas, sin perdida de potencia), app iPhone,
                          Android, combinando tecnologías como HTML5, Angular y/o ReactNative.
                          Desarrollo de AR/VR (Realidad Virtual/Realidad Aumentada). Código fuente 100% original. Lineamientos y metodologías de código fuente seguro del OWASP TOP 10.
                        </Text>
                        <Heading3>
                          <Headinga to="/desarrollo-de-aplicaciones-moviles">
                            Desarrollo de Apps Móviles - APP
                          </Headinga>
                        </Heading3>
                      </AboutContent>
                    
                  </Col>
                </AboutCol>
              </Row>
            </Main>
          </Section>
        )
    }

}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      {
        file(relativePath: { eq: "aplicaciones-moviles-colombia.jpg" }) {
          childImageSharp {
            gatsbyImageData(
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            quality: 80
            formats: [AUTO, WEBP, AVIF]
            width: 500
            )
          }
        }
      }
    `}
    render={(data) => {
      const image = getImage(data.file.childImageSharp.gatsbyImageData);
      return <DeveloperMobile image={image} {...props} />;
    }}
  />
);

export default Iconos;